export default String.raw`

{% include 'partials/common/date-format.html' -%}


<div class="customer-submenu consents-js" data-container=".customer-profile-content-js" data-template="partials/customer-profile/consents/consents.html">
	<div class="customer-submenu__header">
		{{ translations.Agreements }}
	</div>
	{% for tos in customer-profile.Consents -%}
		{% if tos.Checked -%}
			{% assign accepted = true -%}
		{% else -%}
			{% assign toAccept = true -%}
		{% endif -%}
	{% endfor -%}
	{% if accepted -%}
	<div class="consents-title"><h4>{{translations.Accepted}}</h4></div>
			{% for tos in customer-profile.Consents -%}
				{% if tos.Checked -%}
				<div class="customer-info consentsList">
					<div class="form-js consents-wrapper">
						<div class="consents-wrapper__statement"><h4>{{ tos.Text }}</h4></div>
						{% assign channelsSize = tos.Channels | Size -%}
						{% if channelsSize > 0 -%}
							{% assign checkedChannelsSize = 0 -%}
							{% for channel in tos.Channels -%}
									{% if channel.Checked -%}
									<div class="consents-wrapper__date">
										<label>{{channel.Name}}</label>
										<span>{{translations.AcceptanceDate}}: <strong>{{channel.Date | Date:dateFormat}}</strong></span>
									</div>
									<div class="consents-wrapper__buttons">
										<span>{{channel.Name}}</span>
										<button class="secondary-action-button agreements-in-profile-js" data-action="Customer/ConsentWithdraw" data-key="{{ channel.Key }}">{{translations.Withdraw}}</button>
									</div>
										{% assign checkedChannelsSize = checkedChannelsSize | Plus:1 -%}
									{% else -%}
									<div class="consents-wrapper__buttons">
										<span>{{channel.Name}}</span>
										<button class="secondary-action-button agreements-in-profile-js" data-action="Customer/ConsentAccept" data-key="{{ channel.Key }}">{{translations.Accept}}</button>
									</div>
									{% endif -%}
							{% endfor -%}
							{% if tos.Required and checkedChannelsSize == 1 -%}
								<div class="required">{{translations.WithdrawRequiredInfo}}!</div>
							{% endif -%}
						{% else -%}
							<div class="consents-wrapper__date">
								<span>{{translations.AgreementAccepted}}: <strong>{{tos.Date | Date:dateFormat}}</strong></span>
							</div>
							<div class="consents-wrapper__buttons">
							{% if tos.Required -%}
								<div class="required">{{translations.WithdrawRequiredInfo}}!</div>
							{% endif -%}
								<span>{{channel.Name}}</span>
								<button class="secondary-action-button agreements-in-profile-js tos-js" data-action="Customer/ConsentWithDraw" data-key="{{ tos.Id }}">{{translations.WithdrawAgreement}}</button>
							</div>

						{% endif -%}
						{% if tos.Updated -%}
							<div class="consents-wrapper">
								<div class="consents-wrapper__statement">{{translations.UpdatedAgreementInfo}}</div>
								<div class="consents-wrapper__statement">{{tos.Updated.Text}}</div>
								{% assign updatedChannelsSize = tos.Updated.Channels | Size -%}
								{% if updatedChannelsSize > 0 -%}
									{% for channel in tos.Updated.Channels -%}
										<div class="consents-wrapper__buttons">
											<span>{{channel.Name}}</span>
											<button class="primary-action-button agreements-in-profile-js" data-action="Customer/ConsentAccept" data-key="{{ channel.Key }}">{{translations.Accept}}</button>
										</div>
									{% endfor -%}
								{% else -%}
									<div class="consents-wrapper__buttons">
										<span>{{channel.Name}}</span>
										<button class="primary-action-button agreements-in-profile-js tos-js" data-action="Customer/ConsentAccept" data-key="{{ tos.Id }}">{{translations.AcceptAgreement}}</button>
									</div>
								{% endif -%}
							</div>
						{% endif -%}
					</div>
				</div>
				{% endif -%}
			{% endfor -%}
		{% endif -%}
	{% if toAccept -%}
		<div class="consents-title"><h4>{{translations.ToAccept}}</h4></div>
		{% for tos in customer-profile.Consents -%}
			{% if tos.Checked == false -%}
			<div class="customer-info consentsList">
				<div class="form-js consents-wrapper">
					<div class="consents-wrapper__statement"><h4>{{ tos.Text }}</h4></div>
					{% assign channelsSize = tos.Channels | Size -%}
					{% if channelsSize > 0 -%}
						{% for channel in tos.Channels -%}
							<div class="consents-wrapper__buttons">
								<span>{{channel.Name}}</span>
								<button class="primary-action-button agreements-in-profile-js" data-action="Customer/ConsentAccept" data-key="{{ channel.Key }}">{{translations.Accept}}</button>
							</div>
						{% endfor -%}
					{% else -%}
							<div class="consents-wrapper__buttons">
								<span>{{channel.Name}}</span>
								<button class="primary-action-button agreements-in-profile-js tos-js" data-action="Customer/ConsentAccept" data-key="{{ tos.Id }}">{{translations.AcceptAgreement}}</button>
							</div>
					{% endif -%}
				</div>
			</div>
			{% endif -%}
		{% endfor -%}
	{% endif -%}
</div>
`